module.exports = __webpack_public_path__ + "static/img/limit-reward-modal-2.d5a978a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/limit-reward-modal-2.png
// module id = fn6A
// module chunks = 215